// Minimalistyczne SVG piktogramy dla stron autoryzacji

export function IconEnvelope({ size = 64, color = 'var(--acc)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="16" width="48" height="32" rx="3" stroke={color} strokeWidth="2.5" fill="none"/>
      <path d="M8 20l24 16 24-16" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconEnvelopeSent({ size = 64, color = 'var(--acc)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="16" width="48" height="32" rx="3" stroke={color} strokeWidth="2.5" fill="none"/>
      <path d="M8 20l24 16 24-16" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      {/* Znaczek wysłania — mała strzałka w górę */}
      <circle cx="50" cy="14" r="8" fill="var(--bg2)" stroke={color} strokeWidth="2"/>
      <path d="M50 18v-8M47 13l3-3 3 3" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconCheckCircle({ size = 64, color = 'var(--ok2)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="22" stroke={color} strokeWidth="2.5" fill="none"/>
      <path d="M22 32l8 8 12-14" stroke={color} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export function IconXCircle({ size = 64, color = 'var(--err2)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="32" cy="32" r="22" stroke={color} strokeWidth="2.5" fill="none"/>
      <path d="M24 24l16 16M40 24L24 40" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  );
}

export function IconKey({ size = 64, color = 'var(--acc)' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="24" cy="28" r="12" stroke={color} strokeWidth="2.5" fill="none"/>
      <path d="M32 34l20-20M46 20l4 4M40 20l4 4" stroke={color} strokeWidth="2.5" strokeLinecap="round"/>
    </svg>
  );
}
